import { AuctionList } from './components/AuctionList.tsx';
import { apiRoutes } from '../../../../constants/apiRoutes.ts';
import { AuctionType, SaleStatus } from '../../../auctions/types.ts';
import { ActiveAuctionCard } from './components/SaleCards/ActiveAuctionCard.tsx';
import { useAuctionListData } from '../../hooks/useAuctionListData.ts';

export const TimedAuctions = () => {
  const queryParameters = { types: [AuctionType.Timed], status: SaleStatus.Selling };
  const { isEmpty } = useAuctionListData(apiRoutes.auctions.list, queryParameters);

  // Hide component completely when empty and not loading
  if (isEmpty) {
    return null;
  }

  return (
    <AuctionList
      title={'FarmGate Timed Auctions Bidding Open'}
      route={apiRoutes.auctions.list}
      queryParameters={{ types: [AuctionType.Timed], status: SaleStatus.Selling }}
      renderItem={ActiveAuctionCard}
    />
  );
};
